


export const currencyTypes = [
  {
    value: 0,
    label: "Tümü",
  },
  {
    "value": 53,
    "label": "TRY"
  },
  {
    "value": 1,
    "label": "USD"
  },
  {
    "value": 20,
    "label": "EUR"
  },
  {
    "value": 2,
    "label": "DEM"
  },
  {
    "value": 3,
    "label": "AUD"
  },
  {
    "value": 4,
    "label": "ATS"
  },
  {
    "value": 5,
    "label": "BEF"
  },
  {
    "value": 6,
    "label": "DKK"
  },
  {
    "value": 7,
    "label": "FIM"
  },
  {
    "value": 8,
    "label": "FRF"
  },
  {
    "value": 9,
    "label": "NLG"
  },
  {
    "value": 10,
    "label": "SEK"
  },
  {
    "value": 11,
    "label": "CHF"
  },
  {
    "value": 12,
    "label": "ITL"
  },
  {
    "value": 13,
    "label": "JPY"
  },
  {
    "value": 14,
    "label": "CAD"
  },
  {
    "value": 15,
    "label": "KWD"
  },
  {
    "value": 16,
    "label": "NOK"
  },
  {
    "value": 17,
    "label": "GBP"
  },
  {
    "value": 18,
    "label": "SAR"
  },
  {
    "value": 19,
    "label": "XEU"
  },
  {
    "value": 21,
    "label": "AZM"
  },
  {
    "value": 22,
    "label": "BRL"
  },
  {
    "value": 23,
    "label": "BGN"
  },
  {
    "value": 24,
    "label": "CZK"
  },
  {
    "value": 25,
    "label": "CNY"
  },
  {
    "value": 26,
    "label": "EEK"
  },
  {
    "value": 27,
    "label": "GEL"
  },
  {
    "value": 28,
    "label": "INR"
  },
  {
    "value": 29,
    "label": "HKD"
  },
  {
    "value": 30,
    "label": "IQD"
  },
  {
    "value": 31,
    "label": "IRR"
  },
  {
    "value": 32,
    "label": "IEP"
  },
  {
    "value": 33,
    "label": "ESP"
  },
  {
    "value": 34,
    "label": "ILS"
  },
  {
    "value": 35,
    "label": "ISK"
  },
  {
    "value": 36,
    "label": "CYP"
  },
  {
    "value": 37,
    "label": "KGS"
  },
  {
    "value": 38,
    "label": "LVL"
  },
  {
    "value": 39,
    "label": "LYD"
  },
  {
    "value": 40,
    "label": "LBP"
  },
  {
    "value": 41,
    "label": "LTL"
  },
  {
    "value": 42,
    "label": "LUF"
  },
  {
    "value": 43,
    "label": "HUF"
  },
  {
    "value": 44,
    "label": "MYR"
  },
  {
    "value": 45,
    "label": "MXN"
  },
  {
    "value": 46,
    "label": "EGP"
  },
  {
    "value": 47,
    "label": "BBD"
  },
  {
    "value": 48,
    "label": "PLN"
  },
  {
    "value": 49,
    "label": "PTE"
  },
  {
    "value": 50,
    "label": "ROL"
  },
  {
    "value": 51,
    "label": "RUB"
  },
  {
    "value": 52,
    "label": "TWD"
  },
  {
    "value": 54,
    "label": "JOD"
  },
  {
    "value": 55,
    "label": "GRD"
  },
  {
    "value": 56,
    "label": "ARS"
  },
  {
    "value": 57,
    "label": "LAK"
  },
  {
    "value": 58,
    "label": "AOA"
  },
  {
    "value": 59,
    "label": "AED"
  },
  {
    "value": 60,
    "label": "AFN"
  },
  {
    "value": 61,
    "label": "ALL"
  },
  {
    "value": 62,
    "label": "ANG"
  },
  {
    "value": 63,
    "label": "ADP"
  },
  {
    "value": 64,
    "label": "BDT"
  },
  {
    "value": 65,
    "label": "BHD"
  },
  {
    "value": 66,
    "label": "BIF"
  },
  {
    "value": 67,
    "label": "BMD"
  },
  {
    "value": 68,
    "label": "BND"
  },
  {
    "value": 69,
    "label": "BOB"
  },
  {
    "value": 70,
    "label": "BSD"
  },
  {
    "value": 71,
    "label": "BTN"
  },
  {
    "value": 72,
    "label": "BWP"
  },
  {
    "value": 73,
    "label": "BZD"
  },
  {
    "value": 74,
    "label": "CLP"
  },
  {
    "value": 75,
    "label": "COP"
  },
  {
    "value": 76,
    "label": "CRC"
  },
  {
    "value": 77,
    "label": "CUP"
  },
  {
    "value": 78,
    "label": "CVE"
  },
  {
    "value": 79,
    "label": "DJF"
  },
  {
    "value": 80,
    "label": "DOP"
  },
  {
    "value": 81,
    "label": "DZD"
  },
  {
    "value": 82,
    "label": "ECS"
  },
  {
    "value": 83,
    "label": "ETB"
  },
  {
    "value": 84,
    "label": "FJD"
  },
  {
    "value": 85,
    "label": "FKP"
  },
  {
    "value": 86,
    "label": "GHS"
  },
  {
    "value": 87,
    "label": "GIP"
  },
  {
    "value": 88,
    "label": "GMD"
  },
  {
    "value": 89,
    "label": "GNF"
  },
  {
    "value": 90,
    "label": "GTQ"
  },
  {
    "value": 91,
    "label": "GWP"
  },
  {
    "value": 92,
    "label": "GYD"
  },
  {
    "value": 93,
    "label": "HNL"
  },
  {
    "value": 94,
    "label": "HTG"
  },
  {
    "value": 95,
    "label": "IDR"
  },
  {
    "value": 96,
    "label": "JMD"
  },
  {
    "value": 97,
    "label": "KES"
  },
  {
    "value": 98,
    "label": "KHR"
  },
  {
    "value": 99,
    "label": "KMF"
  },
  {
    "value": 100,
    "label": "KPW"
  },
  {
    "value": 101,
    "label": "KRW"
  },
  {
    "value": 102,
    "label": "KYD"
  },
  {
    "value": 103,
    "label": "LKR"
  },
  {
    "value": 104,
    "label": "LRD"
  },
  {
    "value": 105,
    "label": "LSL"
  },
  {
    "value": 106,
    "label": "MAD"
  },
  {
    "value": 107,
    "label": "MNT"
  },
  {
    "value": 108,
    "label": "MOP"
  },
  {
    "value": 109,
    "label": "MRO"
  },
  {
    "value": 110,
    "label": "MTL"
  },
  {
    "value": 111,
    "label": "MUR"
  },
  {
    "value": 112,
    "label": "MVR"
  },
  {
    "value": 113,
    "label": "MWK"
  },
  {
    "value": 114,
    "label": "MZN"
  },
  {
    "value": 115,
    "label": "NGN"
  },
  {
    "value": 116,
    "label": "NIO"
  },
  {
    "value": 117,
    "label": "NPR"
  },
  {
    "value": 118,
    "label": "NZD"
  },
  {
    "value": 119,
    "label": "OMR"
  },
  {
    "value": 120,
    "label": "PAB"
  },
  {
    "value": 121,
    "label": "PEN"
  },
  {
    "value": 122,
    "label": "PGK"
  },
  {
    "value": 123,
    "label": "PHP"
  },
  {
    "value": 124,
    "label": "PKR"
  },
  {
    "value": 125,
    "label": "PYG"
  },
  {
    "value": 126,
    "label": "QAR"
  },
  {
    "value": 127,
    "label": "RWF"
  },
  {
    "value": 128,
    "label": "SBD"
  },
  {
    "value": 129,
    "label": "SCR"
  },
  {
    "value": 130,
    "label": "SDG"
  },
  {
    "value": 131,
    "label": "SGD"
  },
  {
    "value": 132,
    "label": "SHP"
  },
  {
    "value": 133,
    "label": "SLL"
  },
  {
    "value": 134,
    "label": "SOS"
  },
  {
    "value": 135,
    "label": "SRD"
  },
  {
    "value": 136,
    "label": "STD"
  },
  {
    "value": 137,
    "label": "SVC"
  },
  {
    "value": 138,
    "label": "SYP"
  },
  {
    "value": 139,
    "label": "SZL"
  },
  {
    "value": 140,
    "label": "THB"
  },
  {
    "value": 141,
    "label": "TND"
  },
  {
    "value": 142,
    "label": "TPE"
  },
  {
    "value": 143,
    "label": "TTD"
  },
  {
    "value": 144,
    "label": "TZS"
  },
  {
    "value": 145,
    "label": "UGX"
  },
  {
    "value": 146,
    "label": "UYU"
  },
  {
    "value": 147,
    "label": "VEB"
  },
  {
    "value": 148,
    "label": "VND"
  },
  {
    "value": 149,
    "label": "WST"
  },
  {
    "value": 150,
    "label": "YDD"
  },
  {
    "value": 151,
    "label": "YER"
  },
  {
    "value": 152,
    "label": "YUD"
  },
  {
    "value": 153,
    "label": "ZAR"
  },
  {
    "value": 154,
    "label": "ZMK"
  },
  {
    "value": 155,
    "label": "ZWL"
  },
  {
    "value": 156,
    "label": "KZT"
  },
  {
    "value": 157,
    "label": "UAH"
  },
  {
    "value": 158,
    "label": "TMT"
  },
  {
    "value": 159,
    "label": "UZS"
  },
  {
    "value": 160,
    "label": "TL"
  },
  {
    "value": 161,
    "label": "RON"
  },
  {
    "value": 162,
    "label": "AZN"
  },
  {
    "value": 164,
    "label": "AMD"
  },
  {
    "value": 165,
    "label": "AWG"
  },
  {
    "value": 166,
    "label": "KM"
  },
  {
    "value": 167,
    "label": "BYR"
  },
  {
    "value": 168,
    "label": "CDF"
  },
  {
    "value": 169,
    "label": "ERN"
  },
  {
    "value": 170,
    "label": "HRK"
  },
  {
    "value": 171,
    "label": "MDL"
  },
  {
    "value": 172,
    "label": "MGA"
  },
  {
    "value": 173,
    "label": "MKD"
  },
  {
    "value": 174,
    "label": "MMK"
  },
  {
    "value": 175,
    "label": "NAD"
  },
  {
    "value": 176,
    "label": "RSD"
  },
  {
    "value": 177,
    "label": "TJS"
  },
  {
    "value": 178,
    "label": "TOP"
  },
  {
    "value": 179,
    "label": "VEF"
  },
  {
    "value": 180,
    "label": "VUV"
  },
  {
    "value": 181,
    "label": "XAF"
  },
  {
    "value": 182,
    "label": "XCD"
  },
  {
    "value": 183,
    "label": "XOF"
  },
  {
    "value": 184,
    "label": "XPF"
  }
]